import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges } from '@angular/core';

import { PaymentMethod } from '@ridango/core';

@Component({
    selector: 'ridango-single-payment-method',
    templateUrl: './single-payment-method.component.html',
    styleUrls: ['./single-payment-method.component.scss']
})
export class SinglePaymentMethodComponent implements OnInit, OnChanges {
    @Input() method: PaymentMethod;
    @Input() lang = 'en';
    @Input() showTitle = 'true';
    @Output() onMethodSelected = new EventEmitter<PaymentMethod>();
    @Output() onMovedLeft = new EventEmitter<any>();
    @Output() onMovedRight = new EventEmitter<any>();
    @Output() onFocused = new EventEmitter<any>();

    constructor() { }
    ngOnInit() {

    }

    ngOnChanges(changes: SimpleChanges) {
        if (changes.method && changes.method.currentValue) {
            this.methodSelected();
        }
    }

    methodSelected() {
        this.onMethodSelected.emit(this.method);
    }

}
